var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('TrackingNoscript'),_vm._v(" "),_c('div',{staticClass:"docs"},[_c('homepage-header'),_vm._v(" "),_c('v-main',[_c('div',{staticClass:"mastcontent docs__mastcontent"},[_c('div',{staticClass:"docs__wrapper"},[_c('Nuxt')],1)])]),_vm._v(" "),_c('page-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }